module.exports = __webpack_public_path__ + "img/part6.27277997.png";